import { PLATFORM_HIDE_3_USERS_BUCKET } from "constants/cookies";

// There are existing accounts that don't have the 3 users bucket, so we don't want to show it to them
export const shouldSeeThreeUsersBucketAbTest = ({ cookies }) => {
  const platformHide3UsersBucket = cookies[PLATFORM_HIDE_3_USERS_BUCKET];
  if (platformHide3UsersBucket) return platformHide3UsersBucket !== "true";

  return true;
};
